import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderSlot as _renderSlot } from "vue"

const _hoisted_1 = { class: "flex flex-row gap-x-12 z-20 w-full" }
const _hoisted_2 = { class: "flex flex-grow gap-8" }
const _hoisted_3 = { class: "flex gap-2 items-center" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_WeightCost = _resolveComponent("WeightCost")!
  const _component_CheckTariffV2 = _resolveComponent("CheckTariffV2")!
  const _component_SelectPaymentMethods = _resolveComponent("SelectPaymentMethods")!
  const _component_SelectReceiptLanguage = _resolveComponent("SelectReceiptLanguage")!
  const _component_BookV3 = _resolveComponent("BookV3")!

  return (_openBlock(), _createBlock("div", {
    id: _ctx.id,
    class: "relative flex flex-row justify-between items-center z-20 w-10/12",
    style: {"box-shadow":"0 0 20px #e0e0e0","padding":"12px 24px 12px 12px"}
  }, [
    _createVNode("div", _hoisted_1, [
      _createVNode("div", _hoisted_2, [
        _createVNode(_component_WeightCost, {
          formType: _ctx.formType,
          totalItem: _ctx.totalPiece,
          totalGrossWeight: _ctx.totalGrossWeight,
          totalDimensionWeight: _ctx.totalDimensionWeight,
          totalVolumeWeight: _ctx.totalVolumeWeight,
          chargeableWeight: _ctx.estimationPrice.chargeableWeight,
          isCampaign: _ctx.isCampaign,
          id: _ctx.idWeightCost,
          isCustomerApps: _ctx.isCustomerApps
        }, null, 8, ["formType", "totalItem", "totalGrossWeight", "totalDimensionWeight", "totalVolumeWeight", "chargeableWeight", "isCampaign", "id", "isCustomerApps"]),
        _createVNode(_component_CheckTariffV2, {
          modelValue: _ctx.modelValue,
          estimationPrice: _ctx.estimationPrice,
          isDisabled: _ctx.isDisabled,
          form: _ctx.formCheckTariff,
          payload: _ctx.payload,
          formType: _ctx.formType,
          discountData: _ctx.discount,
          isCodRetail: _ctx.isCodRetailApplied,
          goodsValue: _ctx.goodsValue,
          isLoading: _ctx.isLoadingEstimation,
          isError: _ctx.isErrorEstimation,
          id: _ctx.idTariff,
          adjustmentRuleTariff: _ctx.adjustmentRuleTariff,
          onRefresh: _ctx.refreshCheckTariff,
          isEditSttMY: _ctx.isEditSttMY,
          isCustomerApps: _ctx.isCustomerApps,
          clientData: _ctx.clientData,
          isCrossCountryCod: _ctx.isCrossCountryCod
        }, null, 8, ["modelValue", "estimationPrice", "isDisabled", "form", "payload", "formType", "discountData", "isCodRetail", "goodsValue", "isLoading", "isError", "id", "adjustmentRuleTariff", "onRefresh", "isEditSttMY", "isCustomerApps", "clientData", "isCrossCountryCod"]),
        (_ctx.hidePaymentMethod ? false : _ctx.isCreateBookingRetail)
          ? (_openBlock(), _createBlock(_component_SelectPaymentMethods, {
              key: 0,
              id: _ctx.idPaymentMethod,
              isDiscount: _ctx.discount.status,
              payment: _ctx.payment,
              configShowPayment: _ctx.configShowPayment,
              isCreateBookingRetail: _ctx.isCreateBookingRetail,
              isCOD: _ctx.payload.isCOD,
              isDFOD: _ctx.payload.isDFOD
            }, null, 8, ["id", "isDiscount", "payment", "configShowPayment", "isCreateBookingRetail", "isCOD", "isDFOD"]))
          : _createCommentVNode("", true),
        (_ctx.isProductInterpack && _ctx.accountIsNonForeign)
          ? (_openBlock(), _createBlock(_component_SelectReceiptLanguage, {
              key: 1,
              id: _ctx.idReceiptLanguage
            }, null, 8, ["id"]))
          : _createCommentVNode("", true)
      ]),
      _createVNode("div", _hoisted_3, [
        _renderSlot(_ctx.$slots, "footer-right"),
        (_ctx.isButtonSubmit)
          ? (_openBlock(), _createBlock(_component_BookV3, {
              key: 0,
              isDisabled: _ctx.isDisabled,
              bookingType: _ctx.formType,
              payload: _ctx.payload,
              onSubmit: _ctx.submitBookType
            }, null, 8, ["isDisabled", "bookingType", "payload", "onSubmit"]))
          : _createCommentVNode("", true)
      ])
    ])
  ], 8, ["id"]))
}